'use client'

import * as PopoverPrimitive from '@radix-ui/react-popover'

import { TIME_RANGE_FILTER_TEST_IDS } from '@apps/service-map/service-map-test-ids.const'

import { TimeRangeFilterContent } from './components/TimeRangeFilterContent'
import { TimeRangeFilterCustomAndActions } from './components/TimeRangeFilterCustomAndActions'
import { TimeRangeFilterClearButton, TimeRangeFilterTrigger } from './components/TimeRangeFilterTrigger'
import { useTimeRangeFilter } from './hooks/useTimeRangeFilter'
import type { ServiceMapTimeRangeFilterProps } from './time-range.types'

export function ServiceMapTimeRangeFilter({
  id,
  disabled = false,
  sideOffset = 8,
  ...rest
}: ServiceMapTimeRangeFilterProps) {
  const filter = useTimeRangeFilter({ disabled, ...rest })

  return (
    <div data-testid={TIME_RANGE_FILTER_TEST_IDS.root}>
      <PopoverPrimitive.Root open={filter.isOpen} onOpenChange={filter.handleOpenChange}>
        <div className={filter.isChipActive ? filter.triggerChipClass : undefined}>
          <PopoverPrimitive.Trigger asChild>
            <TimeRangeFilterTrigger
              id={id}
              triggerLabel={filter.triggerLabel}
              disabled={disabled}
              isOpen={filter.isOpen}
              ariaTitle={filter.resolvedLabels.title}
              chipActive={filter.isChipActive}
            />
          </PopoverPrimitive.Trigger>
          {filter.isChipActive ? <TimeRangeFilterClearButton disabled={disabled} onClear={filter.handleClear} /> : null}
        </div>
        <PopoverPrimitive.Portal>
          <PopoverPrimitive.Content
            className={filter.panelClass}
            side={filter.side}
            align={filter.align}
            sideOffset={sideOffset}
            collisionPadding={8}
            role="dialog"
            aria-label={filter.resolvedLabels.title}
          >
            <TimeRangeFilterContent
              title={filter.resolvedLabels.title}
              pendingValue={filter.pendingValue}
              onPendingValueChange={filter.handlePendingValueChange}
              gridColumns={filter.gridColumns}
            />
            <TimeRangeFilterCustomAndActions
              showCustomSection={filter.showCustomSection}
              pendingRange={filter.pendingRange}
              sectionLabels={filter.sectionLabels}
              hour12={filter.hour12}
              dateFormat={filter.dateFormat}
              onStartDateChange={filter.setStartDate}
              onStartTimeChange={filter.setStartTime}
              onEndDateChange={filter.setEndDate}
              onEndTimeChange={filter.setEndTime}
              cancelLabel={filter.resolvedLabels.cancel}
              applyLabel={filter.resolvedLabels.apply}
              canApplyCustom={filter.canApplyCustom}
              onCancel={filter.handleCancel}
              onApply={filter.handleApply}
            />
          </PopoverPrimitive.Content>
        </PopoverPrimitive.Portal>
      </PopoverPrimitive.Root>
    </div>
  )
}
